import { Injectable } from '@angular/core';
import { FrameContext, BindingData, BindingList, BindingObject } from '@farris/devkit';

/**
 * å®ä½éåæå¡
 * @todo
 * å®ä½å±æ²¡æå°è£ç¸å³æ¹æ³ï¼ä¸´æ¶éè¿BindingDataæ¥è·åæ°æ®
 */
@Injectable()
class EntityTraversingService {

  private get bindingData(): BindingData {
    return this.frameContext.bindingData;
  }

  constructor(private frameContext: FrameContext) {
  }

  /**
   * è·åå¼
   */
  public getPropValue(path: string[]): any {
    return this.bindingData.getValue(path);
  }

  /**
   * è·åå®ä½æ°æ®
   */
  public getEntityData(path: string[]): any {
    let bindingObj: BindingObject;
    const bindingListOrObject = this.bindingData.getValue(path);
    if (bindingListOrObject instanceof BindingList === true) {
      bindingObj = bindingListOrObject.currentItem;
    } else {
      bindingObj = bindingListOrObject;
    }
    return bindingObj.toJSON();
  }

  /**
   * è·åå®ä½åè¡¨æ°æ®
   */
  public getEntityListData(path: string[]): any[] {
    const bindingList = this.bindingData.getValue(path) as BindingList;
    return bindingList.toJSON();
  }

}

export { EntityTraversingService };
